import * as React from 'react';

import MediaQuery from 'react-responsive';
import { ICalendarAppState } from '../../redux-state';


import MobileResponsive from './mobile';
import DesktopResponsive from './desktop';
import { connect } from 'react-redux';

interface StateToProps {
    mediaWidth: string;
}

interface DispatchToProps {

}

type ResponsiveProps = StateToProps & DispatchToProps;

export class ResponsiveBase extends React.Component<ResponsiveProps, any> {
    //private plusOneWidth: number;
    //private unit: string;

    //private computeMediaQueries(props: ResponsiveProps) {
    //    this.plusOneWidth = parseInt(props.mediaWidth.replace(/[^\d*\.?\d*]/g, ''));
    //    this.unit = props.mediaWidth.replace(/[\d*\.?\d*]/g, '');

    //    // Set the 1 offset depending on the unit of measurement.
    //    if (this.unit === "rem") {
    //        this.plusOneWidth += 0.01;
    //    } else if (this.unit === "px") {
    //        this.plusOneWidth += 1;
    //    }
    //}

    //constructor(props: ResponsiveProps) {
    //    super(props);

    //    this.computeMediaQueries(props);
    //}

    //componentDidUpdate(prevProps: ResponsiveProps) {
    //    this.computeMediaQueries(this.props);
    //}

    render() {
        return (
            <>
                <MediaQuery query={`not all and (max-width: ${this.props.mediaWidth})`}>
                    <DesktopResponsive />
                </MediaQuery>

                <MediaQuery query={`all and (max-width: ${this.props.mediaWidth})`}>
                    <MobileResponsive />
                </MediaQuery>
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        mediaWidth: state.calendarSettings.desktopToMobileTransitionWidth
    }
}

export default connect<StateToProps>(mapStateToProps)(ResponsiveBase);